import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        width: "100%"
      }}
    >
      Property of the University at Buffalo
    </footer>
  );
};

export default Footer;
